import React from "react";
import { FaCalendar, FaLocationDot } from "react-icons/fa6";
import { IoIosStar } from "react-icons/io";
import { MdMedicalServices } from "react-icons/md";
import { docterlist } from "./docterlist";
import { Link } from "react-router-dom";

function Doctorcon() {
  return (
    <>
      <section className="flex justify-center pb-8 pt-0">
        <div className="w-full">
          <div className="flex w-full mt-0">
            <div className="px-0 w-full">
              {docterlist.map((elem) => {
                return (
                  <>
                    <div className="w-full p-2 flex">
                      <div
                        style={{
                          boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
                        }}
                        className="w-full rounded-lg bg-white"
                      >
                        <div className="flex flex-wrap  shadow-sm rounded-md p-4 relative w-full">
                          <div className="w-full flex justify-center  sm:w-1/5">
                            <div className="w-full flex md:block justify-center">
                              <img
                                className="rounded-md mb-4 w-56 sm:w-full object-cover"
                                src={elem.img}
                                style={{
                                  aspectRatio: "2/2",
                                  objectFit: "cover",
                                  objectPosition: "top",
                                }}
                                alt=""
                              />
                            </div>
                          </div>
                          <div className="w-full sm:w-4/5 pl-2">
                            <h6
                              style={{ color: "#3d7cc9" }}
                              className="font-medium"
                            >
                              {elem.name}
                            </h6>
                            {elem.dis}
                            <div className="w-full mt-3 grid grid-cols-1 md:grid-cols-3 gap-4 ">
                              <div className="flex items-center gap-2">
                                <IoIosStar size={20} />
                                <h6 className="text-gray-600 ml-1 md:ml-2 text-sm">
                                  4.6/5
                                </h6>
                              </div>
                              <div className="flex items-center gap-2">
                                <MdMedicalServices size={20} />
                                <h6 className="text-gray-600 ml-1 md:ml-2 text-sm">
                                  {`${elem.exper}+ Years`}
                                </h6>
                              </div>
                              <div className="flex items-center gap-2">
                                <FaLocationDot size={20} />
                                <h6 className="text-gray-600 ml-1 md:ml-2 text-sm">
                                  Bangalore
                                </h6>
                              </div>
                              {elem.consultation && (
                                <div className="flex items-center gap-2">
                                  <FaCalendar size={20} />
                                  <h6 className="text-gray-600 ml-1 md:ml-2 text-sm">
                                    {elem.consultation}
                                  </h6>
                                </div>
                              )}
                            </div>
                            <button className="border-inherit border py-1 px-3 rounded-md mt-3 text-white bg-gray-400 text-sm">
                              {elem.depat}
                            </button>
                            {elem.timings && (
                              <button className="border-inherit border py-1 px-3 rounded-md mt-3 text-white bg-gray-400 text-sm">
                                {elem.timings}
                              </button>
                            )}
                            <div className="w-full mt-4 flex justify-between">
                              <div className="w-5/12 pr-3">
                                <a
                                  href="tel:9535264855"
                                  style={{ border: "1.5px solid #3d7cc9" }}
                                  className="border-inherit border-2 text-black p-1 rounded-md w-full hidden md:flex justify-center text-sm"
                                >
                                  9535264855
                                </a>
                                <a
                                  className="border-inherit border-2 text-black p-1 rounded-md w-full flex justify-center md:hidden text-sm"
                                  href="tel:9535264855"
                                >
                                  Call Us
                                </a>
                              </div>
                              <div className="w-7/12">
                                <div className="flex w-full h-full">
                                  <a
                                    href="tel:9535264855"
                                    style={{ backgroundColor: "#3d7cc9" }}
                                    className="border-inherit border py-1 px-3 rounded-md text-white w-full text-sm h-full text-center"
                                  >
                                    Appointment
                                  </a>
                                </div>
                              </div>
                            </div>

                            <div className="mt-4 mb-4">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: elem.con.slice(0, 350),
                                }}
                              />
                              <Link
                                style={{ color: "blue", fontWeight: "bold" }}
                                to={elem.link}
                              >
                                Read More
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Doctorcon;
